"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ItemTableStyled = require("./ItemTable-styled.js");
var _reactVirtualized = require("react-virtualized");
var _helper = require("./helper");
var _helper2 = require("../resources/helper");
var _helper3 = require("../../utils/helper");
var _MultiSelectActionToolbar = _interopRequireDefault(require("../MultiSelectActionToolbar"));
var _ActionButtonList = _interopRequireDefault(require("../ActionButtonList"));
var _Pagination = _interopRequireDefault(require("../Pagination"));
var _NoItemsIndicator = _interopRequireDefault(require("../NoItemsIndicator"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CheckBox = _interopRequireDefault(require("../CheckBox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ItemTable = function ItemTable(_ref) {
  var _queryResults$results, _queryResults$results6;
  var queryResults = _ref.queryResults,
    actions = _ref.actions,
    singleItemActions = _ref.singleItemActions,
    handleQueryChange = _ref.handleQueryChange,
    itemBrowserState = _ref.itemBrowserState,
    getUserFolders = _ref.getUserFolders,
    sortField = _ref.sortField,
    sortOrder = _ref.sortOrder,
    session = _ref.session,
    selectedItemIds = _ref.selectedItemIds,
    setSelectedItemIds = _ref.setSelectedItemIds,
    browserView = _ref.browserView,
    portal = _ref.portal,
    customCellRenderer = _ref.customCellRenderer,
    itemGroups = _ref.itemGroups,
    visibleActionsCount = _ref.visibleActionsCount,
    customTableColumnConfig = _ref.customTableColumnConfig,
    columnConfig = _ref.columnConfig,
    customItemIdKey = _ref.customItemIdKey,
    other = _objectWithoutProperties(_ref, ["queryResults", "actions", "singleItemActions", "handleQueryChange", "itemBrowserState", "getUserFolders", "sortField", "sortOrder", "session", "selectedItemIds", "setSelectedItemIds", "browserView", "portal", "customCellRenderer", "itemGroups", "visibleActionsCount", "customTableColumnConfig", "columnConfig", "customItemIdKey"]);
  var itemIdentifier = customItemIdKey ? customItemIdKey : "id";
  var allItemsSelected = (selectedItemIds === null || selectedItemIds === void 0 ? void 0 : selectedItemIds.length) === (queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$results = queryResults.results) === null || _queryResults$results === void 0 ? void 0 : _queryResults$results.length);
  var clearSelectedItems = function clearSelectedItems() {
    setSelectedItemIds([]);
  };
  var rowGetter = function rowGetter(_ref2) {
    var _queryResults$results2;
    var index = _ref2.index;
    return queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$results2 = queryResults.results) === null || _queryResults$results2 === void 0 ? void 0 : _queryResults$results2[index];
  };
  (0, _react.useEffect)(function () {
    var _queryResults$results3;
    var queryResultIds = queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$results3 = queryResults.results) === null || _queryResults$results3 === void 0 ? void 0 : _queryResults$results3.map(function (result) {
      return result[itemIdentifier];
    });
    var filteredQueryResultIds = queryResultIds === null || queryResultIds === void 0 ? void 0 : queryResultIds.filter(function (resultId) {
      return selectedItemIds === null || selectedItemIds === void 0 ? void 0 : selectedItemIds.includes(resultId);
    });
    if ((filteredQueryResultIds === null || filteredQueryResultIds === void 0 ? void 0 : filteredQueryResultIds.join()) !== (selectedItemIds === null || selectedItemIds === void 0 ? void 0 : selectedItemIds.join()) && !!setSelectedItemIds) {
      setSelectedItemIds(filteredQueryResultIds);
    }
  }, [customItemIdKey, itemIdentifier, queryResults, selectedItemIds, setSelectedItemIds]);

  // Refactor to accept id instead of index. Rename items/selectedItemIds to read itemIds and selectedItemIds
  var updateSelectedItems = function updateSelectedItems(itemIndex, event) {
    var items = _toConsumableArray(selectedItemIds);
    if (event.target.checked) {
      items = [].concat(_toConsumableArray(items), [queryResults === null || queryResults === void 0 ? void 0 : queryResults.results[itemIndex][itemIdentifier]]);
    } else {
      items = selectedItemIds.filter(function (selectedItem) {
        return selectedItem !== (queryResults === null || queryResults === void 0 ? void 0 : queryResults.results[itemIndex][itemIdentifier]);
      });
    }
    setSelectedItemIds(items);
  };
  var updateAllItemsSelected = function updateAllItemsSelected() {
    var updatedAllItems = [];
    if (!allItemsSelected) {
      var _queryResults$results4;
      updatedAllItems = queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$results4 = queryResults.results) === null || _queryResults$results4 === void 0 ? void 0 : _queryResults$results4.map(function (result) {
        return result[itemIdentifier];
      });
    }
    setSelectedItemIds(updatedAllItems);
  };
  var selectionHeaderRenderer = function selectionHeaderRenderer() {
    return /*#__PURE__*/_react.default.createElement(_CheckBox.default, {
      allItemsSelected: allItemsSelected,
      onCalciteCheckboxChange: updateAllItemsSelected
    });
  };
  var selectionCellRenderer = function selectionCellRenderer(_ref3) {
    var _queryResults$results5;
    var rowIndex = _ref3.rowIndex;
    var itemIsSelected = selectedItemIds.includes(queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$results5 = queryResults.results[rowIndex]) === null || _queryResults$results5 === void 0 ? void 0 : _queryResults$results5[itemIdentifier]);
    return (queryResults === null || queryResults === void 0 ? void 0 : queryResults.results) && /*#__PURE__*/_react.default.createElement(_CheckBox.default, {
      allItemsSelected: allItemsSelected,
      itemIsSelected: itemIsSelected,
      onCalciteCheckboxChange: function onCalciteCheckboxChange(event) {
        return updateSelectedItems(rowIndex, event);
      }
    });
  };
  var actionsCellRenderer = function actionsCellRenderer(_ref4, visibleActionsCount) {
    var rowData = _ref4.rowData;
    return /*#__PURE__*/_react.default.createElement(_ActionButtonList.default, {
      actions: singleItemActions,
      collapsed: true,
      itemId: rowData[itemIdentifier],
      visibleActionsCount: visibleActionsCount
    });
  };
  var usersCellRenderer = function usersCellRenderer(_ref5) {
    var rowIndex = _ref5.rowIndex,
      id = _ref5.rowData.id;
    var usersActions = (0, _helper.getFilteredSharingActions)({
      rowIndex: rowIndex,
      queryResults: queryResults,
      sharingActions: _helper2.sharingActions
    });
    return /*#__PURE__*/_react.default.createElement(_ActionButtonList.default, {
      actions: usersActions,
      itemId: id,
      itemGroups: itemGroups
    });
  };

  // Passes React Virtualized sort props to queryBuilder
  var sort = function sort(sortProps) {
    handleQueryChange({
      sortBy: sortProps.sortBy,
      sortDirection: sortProps.sortDirection.toLowerCase()
    });
  };
  var getMenuLocationTitle = function getMenuLocationTitle() {
    switch (browserView) {
      case "content":
        var selectedFolder = (0, _helper3.getSelectedFolder)(itemBrowserState);
        return selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.title;
      default:
        return _helper3.browserViewTitles[browserView] || "results";
    }
  };
  var getCellRenderer = function getCellRenderer(configItemId, props) {
    if (customCellRenderer === null || customCellRenderer === void 0 ? void 0 : customCellRenderer[configItemId]) {
      return (0, _helper.cellRenderer)(props, portal, customCellRenderer[configItemId]);
    }
    switch (configItemId) {
      case "title":
        return (0, _helper.cellRenderer)(props, portal);
      case "actions":
        return actionsCellRenderer(props, visibleActionsCount);
      case "sharing":
        return usersCellRenderer(props);
      default:
        return (0, _helper.cellRenderer)(props);
    }
  };
  var headerHeight = 40;
  var rowHeight = 50;
  var tableHeight = (queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$results6 = queryResults.results) === null || _queryResults$results6 === void 0 ? void 0 : _queryResults$results6.length) * rowHeight + headerHeight;
  var customCheckboxStyles = {
    minWidth: "25px",
    maxWidth: "25px",
    display: "flex",
    justifyContent: "center",
    height: "100%",
    alignItems: "center"
  };
  if (customTableColumnConfig) {
    columnConfig = customTableColumnConfig;
  }
  return (queryResults === null || queryResults === void 0 ? void 0 : queryResults.total) ? /*#__PURE__*/_react.default.createElement(_ItemTableStyled.StyledItemTable, other, /*#__PURE__*/_react.default.createElement(_MultiSelectActionToolbar.default, {
    queryResults: queryResults,
    items: selectedItemIds,
    actions: actions,
    clearSelectedItems: clearSelectedItems,
    userSession: session,
    handleQueryChange: handleQueryChange,
    itemBrowserState: itemBrowserState,
    getUserFolders: getUserFolders,
    menuLocationTitle: getMenuLocationTitle()
  }), /*#__PURE__*/_react.default.createElement(_reactVirtualized.AutoSizer, {
    disableHeight: true
  }, function (_ref6) {
    var _queryResults$results7;
    var width = _ref6.width;
    return /*#__PURE__*/_react.default.createElement(_reactVirtualized.Table, {
      width: width,
      height: tableHeight,
      headerHeight: headerHeight,
      rowHeight: rowHeight,
      rowCount: (queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$results7 = queryResults.results) === null || _queryResults$results7 === void 0 ? void 0 : _queryResults$results7.length) || 0,
      rowGetter: rowGetter,
      headerStyle: {
        width: width,
        display: "flex",
        alignItems: "center"
      },
      style: {
        fontSize: "0.85rem"
      },
      rowStyle: _helper.rowStyle,
      sort: sort,
      sortBy: sortField,
      sortDirection: sortOrder === null || sortOrder === void 0 ? void 0 : sortOrder.toUpperCase()
    }, /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
      cellRenderer: selectionCellRenderer,
      headerRenderer: selectionHeaderRenderer,
      label: "",
      dataKey: "",
      flexGrow: 1,
      flexShrink: 1,
      width: 50,
      style: customCheckboxStyles,
      headerStyle: customCheckboxStyles,
      disableSort: true
    }), columnConfig.map(function (configItem) {
      return /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
        key: configItem.id,
        cellRenderer: function cellRenderer(props) {
          return getCellRenderer(configItem.id, props);
        },
        label: configItem.label,
        dataKey: configItem.dataKey,
        flexGrow: 1,
        flexShrink: 1,
        width: configItem.flexBasis,
        disableSort: !(configItem === null || configItem === void 0 ? void 0 : configItem.filterable)
      });
    }));
  }), queryResults && (queryResults === null || queryResults === void 0 ? void 0 : queryResults.total) > (queryResults === null || queryResults === void 0 ? void 0 : queryResults.num) && /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    handleQueryChange: handleQueryChange,
    clearSelectedItems: clearSelectedItems,
    queryResults: queryResults
  })) : /*#__PURE__*/_react.default.createElement(_NoItemsIndicator.default, null);
};
ItemTable.propTypes = {
  actions: _propTypes.default.array,
  singleItemActions: _propTypes.default.array,
  session: _propTypes.default.object,
  handleQueryChange: _propTypes.default.func,
  itemBrowserState: _propTypes.default.object.isRequired
};
var _default = ItemTable;
exports.default = _default;